<template>
    <div>
        <div class="content-header">
            <PageTitleComponent title="Gestión de butacas"/>
        </div>
        <section class="content">
            <div class="container-fluid">
                <TabsPanel :tabs="tabs" :initialTab="initialTab">
                    <template #tab-region>
                        <RegionesTab />
                    </template>
                    <template #tab-planoGeneral>
                        <PlanoGeneralTab />
                    </template>
                </TabsPanel>
            </div>
        </section>
    </div>
</template>

<script setup>
    import { computed } from 'vue'
    import store from '@/store'
    import PageTitleComponent from '@/components/backend/components/PageTitleComponent'
    import TabsPanel from '@/modules/admin/ui/TabsPanel.vue'
    import PlanoGeneralTab from './tabs/PlanoGeneralTab.vue'
    import RegionesTab from './tabs/RegionesTab.vue'

    

    const place = computed(() => store.getters.getRecinto)

    const tabs = computed(() => [
        {
            key: 'region',
            label: 'Región',
            show: place.value?.svg_teatros
        },
        {
            key: 'planoGeneral',
            label: 'Plano general',
            show: place.value?.url_svg_asientos && place.value?.tipo_proceso_taquilla !== 2
        }
    ])

    const initialTab = computed(() => {
        if (!place.value?.url_svg_asientos || place.value?.tipo_proceso_taquilla === 2) {
            return 'region'
        }
        return 'planoGeneral'
    })
</script>
